import { Box, styled } from '@mui/material'

export const RootContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.background.paper,
}))

export const ScrollableContainer = styled(Box)(({ theme }) => ({
  paddingLeft: '15px',
  paddingRight: '15px',
  marginTop: theme.spacing(1),
  overflowY: 'auto',
  flex: 1,
  minHeight: 0,
}))
